const brandMark = (name = "") => {
  if (name.toLowerCase().includes("nxs")) return "NXS";
  return name.replace(/[^a-z0-9]/gi, "").slice(0, 2).toUpperCase();
};

export function Ecosystem({ content, media = [] }) {
  return (
    <section id="ecosystem" className="section ecosystem-section" data-testid="ecosystem-section">
      <div className="section-heading wide">
        <p className="overline" data-testid="ecosystem-overline">{content.overline}</p>
        <h2 data-testid="ecosystem-title">{content.title}</h2>
        <p data-testid="ecosystem-description">{content.description}</p>
      </div>

      <div className="ecosystem-grid" data-testid="ecosystem-grid">
        {content.items.map((item, index) => (
          <article className="ecosystem-card" key={item.name} data-testid={`ecosystem-card-${index + 1}`}>
            <div className="ecosystem-brand-mark" data-testid={`ecosystem-brand-mark-${index + 1}`}>
              {media[index]?.image ? (
                <img src={media[index].image} alt={`${item.name} logo`} data-testid={`ecosystem-brand-image-${index + 1}`} />
              ) : (
                <span aria-hidden="true">{brandMark(item.name)}</span>
              )}
            </div>
            <p className="ecosystem-relationship" data-testid={`ecosystem-relationship-${index + 1}`}>{item.relationship}</p>
            <h3 data-testid={`ecosystem-name-${index + 1}`}>{item.name}</h3>
            <p className="ecosystem-copy" data-testid={`ecosystem-copy-${index + 1}`}>{item.description}</p>
          </article>
        ))}
      </div>
    </section>
  );
}